module.exports = __webpack_public_path__ + "static/grandprize-prize-games-en-GB-c91b8e7a03cf07dc55a7a4e3bf91828d.png";